import { requestNestMethod } from "../nest/client"

export interface ProviderQueryRequest {
    providerId: string
    prompt: string
    model?: string
    appendSystemPrompt?: string
    timeoutMs?: number
}

export async function runProviderQuery(req: ProviderQueryRequest): Promise<{ text: string }> {
    const response = await requestNestMethod("provider.query.run", req)
    const cleanupFailure = response.diagnostics?.find((diagnostic) => diagnostic.code === "ephemeral_session_cleanup_failed")
    if (cleanupFailure) {
        throw new Error(`Temporary ${req.providerId} session ${response.providerSessionId ?? "(unknown)"} cleanup failed: ${cleanupFailure.message}`)
    }
    return { text: response.text }
}
